import { api, createErrorResponse } from './index';

export const DISALLOWED_PATCH_KEYS = [
  'createdAt',
  'originalFilename',
  'owner',
  'updatedAt',
];

export async function getMedia(limit = 9999, ...rest) {
  try {
    const response = await api.get('media', {
      params: {
        n: limit,
        ...rest,
      },
    });
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function getMediaById(uuid) {
  try {
    const response = await api.get(`media/${uuid}`);
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function deleteMediaById(uuid) {
  try {
    const response = await api.delete(`media/${uuid}`);
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function patchMediaById(uuid, data) {
  try {
    const response = await api.patch(`media/${uuid}`, data);
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function postMediaUpload(file, config = {}) {
  try {
    const data = new FormData();
    data.append('file', file);
    const response = await api.post('media/upload', data, config);
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function postMedia(data) {
  try {
    const response = await api.post('media', data);
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}

export async function updateExistingMediaById(uuid, file, config = {}) {
  try {
    const data = new FormData();
    data.append('file', file);
    const response = await api.post(`media/upload/${uuid}`, data, config);
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}
